import { SsoIntegrationWidgetWebComponent } from './component/SsoIntegrationWidgetWebComponent';

export { SsoIntegrationWidgetWebComponent };
